var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-factory"},[_c(_vm.slideComponent,{tag:"component",attrs:{"data":_vm.slideData.data,"slide-id":_vm.slideData.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }